import styled from "styled-components"

export default function AddressForm({ address, zipcode, onClick }) {
  return (
    <ZipcodeBlock>
      <ZipcodeLabel>우편번호</ZipcodeLabel>
      <ZipcodeTextBlock onClick={onClick}>
        <ZipcodeText>{`${zipcode} ${address}`}</ZipcodeText>
        <ZipcodeChangeBtn>수정</ZipcodeChangeBtn>
      </ZipcodeTextBlock>
    </ZipcodeBlock>
  )
}

const ZipcodeBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: calc(100vw * (28 / 375));
`

const ZipcodeLabel = styled.label`
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: calc(100vw * (17 / 375));
  margin-bottom: calc(100vw * (13 / 375));
`

const ZipcodeTextBlock = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #d5d5d5;
  border-radius: calc(100vw * (5 / 375));
  padding: calc(100vw * (14 / 375)) calc(100vw * (11 / 375));
`

const ZipcodeText = styled.span`
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: calc(100vw * (14 / 375));
  font-weight: 400;
`

const ZipcodeChangeBtn = styled.span`
  font-weight: 700;
  color: #ff9b57;
`
